import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 导入语言包
import en from './locales/en.json';
import zh from './locales/zh.json';

Vue.use(VueI18n);

// 创建i18n实例
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh', // 默认语言
  fallbackLocale: 'zh', // 回退语言
  messages: {
    en,
    zh
  }
});

export default i18n;